import { nanoid } from "nanoid";

const items = [
    
    {
        id: nanoid(),
        text: "PhonebookPage",
        link: "/contacts",
        private: true
    },
];

export default items;